import { useTenantConfig } from '../hooks/useTenantConfig';
import './EnvironmentBadge.css';

// Environment indicator only. The deployed build version moved to the Admin
// "About" card (#600) so it no longer competes with the brand in the navbar.
const EnvironmentBadge: React.FC = () => {
  const tenant = useTenantConfig();
  const isLocalhost = window.location.hostname === 'localhost' ||
                      window.location.hostname === '127.0.0.1';

  const worktreeName = import.meta.env.VITE_WORKTREE_NAME || 'dev';
  const tenantBadge = tenant.ui?.environment_badge?.trim();
  const label = tenantBadge || (isLocalhost ? worktreeName : '');

  if (!label) return null;

  return (
    <span className={tenantBadge ? 'lm-env-badge lm-env-badge--tenant' : 'lm-env-badge'}>
      {label}
    </span>
  );
};

export default EnvironmentBadge;
